var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_component-trigger",
      class: _vm.componentClass,
      on: {
        click: function($event) {
          return _vm.$emit("input", !_vm.value)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }